var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 372.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-1, .cls-4 {\r\n        fill: #407bff;\r\n      }\r\n\r\n      .cls-2, .cls-5, .cls-6, .cls-7 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: none;\r\n        stroke: #407bff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.3px;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #ed847e;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #ebebeb;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #f0f0f0;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #f5f5f5;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #e8bfbf;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #fafafa;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #e0e0e0;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #263238;\r\n      }\r\n\r\n      .cls-18, .cls-19 {\r\n        opacity: .2;\r\n      }\r\n\r\n      .cls-20, .cls-7 {\r\n        opacity: .3;\r\n      }\r\n\r\n      .cls-19, .cls-21 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-21 {\r\n        opacity: .6;\r\n      }\r\n\r\n      .cls-6 {\r\n        opacity: .7;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 416.78,
    y: 343.54,
    width: 33.12,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 322.53,
    y: 346.26,
    width: 8.69,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 396.59,
    y: 334.26,
    width: 19.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 52.46,
    y: 335.94,
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 104.56,
    y: 335.94,
    width: 6.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 131.47,
    y: 340.16,
    width: 93.68,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M238.4,282.85H45.3c-3.15,0-5.71-2.56-5.71-5.71V5.71c0-3.15,2.56-5.71,5.71-5.71H238.4c3.15,0,5.71,2.56,5.71,5.71V277.14c0,3.15-2.56,5.71-5.71,5.71ZM45.3,.25c-3.01,0-5.46,2.45-5.46,5.46V277.14c0,3.01,2.45,5.46,5.46,5.46H238.4c3.01,0,5.46-2.45,5.46-5.46V5.71c0-3.01-2.45-5.46-5.46-5.46H45.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M454.7,282.85h-193.1c-3.15,0-5.71-2.56-5.71-5.71V5.71c0-3.15,2.56-5.71,5.71-5.71h193.1c3.15,0,5.71,2.56,5.71,5.71V277.14c0,3.15-2.56,5.71-5.71,5.71ZM261.6,.25c-3.01,0-5.46,2.45-5.46,5.46V277.14c0,3.01,2.45,5.46,5.46,5.46h193.1c3.01,0,5.46-2.45,5.46-5.46V5.71c0-3.01-2.45-5.46-5.46-5.46h-193.1Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    y: 327.45,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 350.07,
    y: 194.99,
    width: 95.18,
    height: 126.65,
    transform: "translate(795.32 516.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 331.92,
    y: 194.99,
    width: 18.16,
    height: 126.65,
    transform: "translate(681.99 516.64) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 356.25,
    y: 204.39,
    width: 82.33,
    height: 30.76,
    transform: "translate(794.83 439.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M408.15,204.39l-.36,4.1c-.12,1.35-1.25,2.39-2.61,2.39h-15.54c-1.36,0-2.49-1.04-2.61-2.39l-.36-4.1h21.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 356.25,
    y: 238.51,
    width: 82.33,
    height: 30.76,
    transform: "translate(794.83 507.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M408.15,238.51l-.36,4.1c-.12,1.35-1.25,2.39-2.61,2.39h-15.54c-1.36,0-2.49-1.04-2.61-2.39l-.36-4.1h21.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 356.25,
    y: 272.62,
    width: 82.33,
    height: 30.76,
    transform: "translate(794.83 576) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M408.15,272.62l-.36,4.1c-.12,1.35-1.25,2.39-2.61,2.39h-15.54c-1.36,0-2.49-1.04-2.61-2.39l-.36-4.1h21.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "356.25 327.96 437.58 327.96 438.58 321.63 356.25 321.63 356.25 327.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "339.25 327.96 356.25 327.96 356.25 321.63 338.25 321.63 339.25 327.96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "394.48 195.13 426.98 195.13 423.38 153.92 390.88 153.92 394.48 195.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "394.48 195.13 392.93 195.13 389.32 153.92 390.88 153.92 394.48 195.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "397.43 190.93 423.3 190.93 420.43 158.12 394.56 158.12 397.43 190.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "399.32 188.23 420.93 188.23 418.54 160.82 396.92 160.82 399.32 188.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "385.35 195.13 387.58 169.62 355.23 169.62 353 195.13 385.35 195.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "385.35 195.13 387.58 169.62 389.32 169.62 387.09 195.13 385.35 195.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "382.28 192.53 384.06 172.22 358.3 172.22 356.52 192.53 382.28 192.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "380.3 190.86 381.79 173.89 360.27 173.89 358.79 190.86 380.3 190.86"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M310.64,310.82c0,6.76-1.06,11.13-2.85,13.94-1.34,2.11-3.76,3.3-6.26,3.3h-9.79c-2.5,0-4.91-1.19-6.26-3.3-1.79-2.81-2.85-7.18-2.85-13.94,0-9.81,4.27-17.65,5.67-23.92,.5-2.26-1.17-9.17-1.17-9.17h19s-1.67,6.92-1.17,9.17c1.4,6.27,5.67,14.12,5.67,23.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M343,271.13c0-8.51-13.35-4.98-16.71-18.19-1.27-5,9.58-16.33,9.58-16.33h-33.85s10.86,11.33,9.58,16.33c-3.36,13.21-16.71,9.67-16.71,18.19,0,9.38,18.83,28.9,19.73,50.88,.08,1.96-3.54,6.04-3.54,6.04h15.72s-3.62-4.07-3.54-6.04c.91-21.98,19.73-41.51,19.73-50.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332.77,293.26c1.97-4.14-2.1-18.21-2.1-18.21h14.67s-4.07,14.07-2.1,18.21c1.39,2.92,4.55,4.79,4.55,8.24v20.77c0,5.38-4.4,5.78-9.78,5.78s-9.78-.4-9.78-5.78v-20.77c0-3.46,3.16-5.32,4.55-8.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M165.15,170.58c-8.43-3.65-13.23-11.35-10.72-17.17,2.52-5.82,11.42-7.58,19.85-3.93,8.43,3.65,13.24,11.35,10.72,17.17-2.52,5.82-11.42,7.58-19.85,3.93Zm6.71-15.49c-3.95-1.71-8.12-.88-9.3,1.84-1.18,2.73,1.07,6.33,5.02,8.04,3.95,1.71,8.12,.88,9.3-1.84,1.18-2.73-1.07-6.33-5.02-8.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M175.07,155.41l-4-1.73,24.2-55.94c.48-1.11,1.76-1.61,2.87-1.14h0c1.11,.48,1.61,1.76,1.14,2.87l-24.2,55.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "201.12 104.88 193.43 101.52 195.17 97.52 202.85 100.87 201.12 104.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.33 109.36 191.83 106.97 193.56 102.96 199.06 105.35 197.33 109.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 191.37,
    y: 110.59,
    width: 4.36,
    height: 6.72,
    transform: "translate(12.07 246.28) rotate(-66.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M176.62,149.44l-2.2-.95c-1.1-.47-1.6-1.75-1.13-2.84v-.03c.49-1.1,1.76-1.6,2.86-1.13l2.2,.95c1.1,.47,1.6,1.75,1.13,2.84v.03c-.49,1.1-1.76,1.6-2.86,1.13Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M348.47,130.21c6.68,4.45,8.4,13.64,3.84,20.48-4.56,6.84-13.7,8.79-20.38,4.35-6.68-4.45-8.4-13.64-3.84-20.48,4.56-6.84,13.7-8.79,20.38-4.34Zm-12.15,18.23c3.13,2.08,7.41,1.17,9.55-2.04,2.14-3.21,1.33-7.51-1.8-9.6-3.13-2.08-7.41-1.17-9.55,2.04-2.14,3.21-1.33,7.51,1.8,9.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M334.71,146.66l4.14,2.76-29.61,45.32c-.76,1.14-2.31,1.45-3.45,.69h0c-1.14-.76-1.45-2.3-.69-3.45l29.61-45.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M305.28,182.1l8.71,5.85-4.35,6.53-8.73-5.86c-1.25-.84-1.59-2.54-.75-3.79l1.31-1.97c.84-1.26,2.55-1.6,3.81-.76Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M227.54,43.6l-4.6,11.91c-.41,1.07-1.62,1.61-2.69,1.19-1.07-.41-1.61-1.62-1.19-2.69l4.6-11.91c1.48-3.85-.44-8.18-4.28-9.67l-4.26-1.64c-3.85-1.48-8.18,.44-9.67,4.28l-1.88,4.86-3.89-1.5,1.88-4.86c2.31-5.99,9.07-8.98,15.05-6.67l4.26,1.64c5.99,2.31,8.98,9.07,6.67,15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M226.81,45.48c-.31-.39-.72-.72-1.22-.91l-23.2-8.96c-.52-.2-1.06-.24-1.57-.14-.93,.18-1.75,.82-2.11,1.77l-8.96,23.2c-.57,1.47,.16,3.11,1.63,3.68l23.2,8.96c1.47,.57,3.11-.16,3.68-1.63l8.96-23.2c.37-.96,.19-2.01-.41-2.77Zm-17.62,17.93l-7.36-2.84,3.89-6.79c-.49-.99-.58-2.17-.15-3.28,.81-2.1,3.17-3.15,5.28-2.34s3.15,3.18,2.34,5.28c-.43,1.11-1.29,1.92-2.32,2.32l-1.68,7.65Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 69.16,
    y: 214.87,
    width: 185.13,
    height: 99.63,
    transform: "translate(323.44 529.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 239.44,
    y: 318.64,
    width: 11.64,
    height: 8.79,
    transform: "translate(490.52 646.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 55.03,
    y: 207.46,
    width: 11.64,
    height: 119.97,
    transform: "translate(121.69 534.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66.52,207.46v119.97h6.21v-6.72H251.08v6.72h6.21v-119.97H66.52Zm6.21,10.86h86.07v41.67H72.73v-41.67Zm178.35,91.53h-86.07v-91.53h86.07v91.53Zm-178.35,0v-43.66h86.07v43.66H72.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 165.01,
    y: 222.8,
    width: 80.26,
    height: 87.05,
    transform: "translate(410.27 532.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M168.64,263.72c0,2.06,1.67,3.73,3.73,3.73s3.73-1.67,3.73-3.73-1.67-3.73-3.73-3.73-3.73,1.67-3.73,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M172.37,267.45c1.5,0,2.79-.9,3.38-2.18,.22,.47,.35,1,.35,1.55,0,2.06-1.67,3.73-3.73,3.73s-3.73-1.67-3.73-3.73c0-.56,.13-1.08,.35-1.55,.59,1.28,1.88,2.18,3.38,2.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "214.14 309.85 194.99 309.85 185.84 222.8 204.99 222.8 214.14 309.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "190.09 309.85 186.27 309.85 177.13 222.8 180.94 222.8 190.09 309.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 139.4,
    y: 222.71,
    width: 7.58,
    height: 37.23,
    transform: "translate(286.39 482.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 107.96,
    y: 222.71,
    width: 7.58,
    height: 37.23,
    transform: "translate(223.5 482.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 131.82,
    y: 225.33,
    width: 7.58,
    height: 34.62,
    transform: "translate(271.22 485.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 115.54,
    y: 225.33,
    width: 7.58,
    height: 34.62,
    transform: "translate(238.66 485.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 123.12,
    y: 222.71,
    width: 4.9,
    height: 37.23,
    transform: "translate(251.15 482.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 128.03,
    y: 225.33,
    width: 3.79,
    height: 34.62,
    transform: "translate(259.84 485.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 100.37,
    y: 222.71,
    width: 7.58,
    height: 37.23,
    transform: "translate(208.33 482.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 92.79,
    y: 225.33,
    width: 7.58,
    height: 34.62,
    transform: "translate(193.16 485.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 76.51,
    y: 225.33,
    width: 7.58,
    height: 34.62,
    transform: "translate(160.6 485.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 84.09,
    y: 222.71,
    width: 4.9,
    height: 37.23,
    transform: "translate(173.09 482.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 88.99,
    y: 225.33,
    width: 3.79,
    height: 34.62,
    transform: "translate(181.78 485.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 72.72,
    y: 223.6,
    width: 3.79,
    height: 36.35,
    transform: "translate(149.23 483.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 72.72,
    y: 272.62,
    width: 7.58,
    height: 37.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 104.16,
    y: 272.62,
    width: 7.58,
    height: 37.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 80.3,
    y: 275.23,
    width: 7.58,
    height: 34.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 96.58,
    y: 275.23,
    width: 7.58,
    height: 34.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 91.68,
    y: 272.62,
    width: 4.9,
    height: 37.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 87.89,
    y: 275.23,
    width: 3.79,
    height: 34.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.75,
    y: 272.62,
    width: 7.58,
    height: 37.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 119.33,
    y: 275.23,
    width: 7.58,
    height: 34.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 135.61,
    y: 275.23,
    width: 7.58,
    height: 34.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 130.71,
    y: 272.62,
    width: 4.9,
    height: 37.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 146.99,
    y: 272.62,
    width: 4.9,
    height: 37.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 126.92,
    y: 275.23,
    width: 3.79,
    height: 34.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 143.19,
    y: 273.5,
    width: 3.79,
    height: 36.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M81.18,143.34s-1.27,.59-1.85,1.77c-.58,1.18,1.22,3.37,1.22,3.37,0,0,1.52,1.06,3.02,.37l1.51-.68s-2.57-4.47-3.82-4.51l-.07-.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M87.63,143.3c.18,2.12-1.13,4.79-3.02,4.96-1.89,.16-3.65-2.24-3.83-4.36-.18-2.12,1.34-2.33,3.24-2.49,1.89-.16,3.43-.22,3.62,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M82.08,142.68s1.45,1.15,4.43,.48c0,0-4.7,3.13-4.43-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M83.36,142.26s1.67-.29,1.69,.41c0,0,1.41-.08,1.22-.67-.2-.59-2.91,.27-2.91,.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M82.08,142.68s1.45,1.15,4.43,.48c0,0-4.7,3.13-4.43-.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M83.36,142.26s1.67-.29,1.69,.41c0,0,1.41-.08,1.22-.67-.2-.59-2.91,.27-2.91,.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M81.43,148.93c.6,.98,1.83,1.48,2.97,1.34,1.14-.14,2.16-.85,2.82-1.79,.66-.94,.97-2.09,1.04-3.23,.02-.3,.04-1.04-.35-1.15-.36-.1-.58,.4-.74,.63-.48,.67-.98,1.3-1.59,1.86-.59,.54-1.24,1.02-1.94,1.41-.2,.11-2.1,1.1-2.21,.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M89.55,144.7c.36,.86,.23,1.9-.33,2.65-.37,.49-.89,.84-1.41,1.15-.36,.22-.83,.43-1.19,.2-.39-.25-.35-.81-.26-1.27,.14-.69,.29-1.38,.46-2.07,.14-.56,.23-1.5,.56-1.98,.31-.45,.75-.18,1.22,.14,.42,.29,.76,.7,.96,1.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M81.91,147.75c-.73-.03-1.42-.53-1.69-1.21-.2-.5-.19-1.78,.46-1.95,.29,1.14,.54,2.17,1.23,3.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M86.84,147.7c.69-.2,1.26-.76,1.47-1.45,.12-.38-.03-2.32-.61-1.5-.19,.27-.15,1.12-.25,1.46-.15,.52-.35,1.02-.62,1.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M84.2,148.9c.53,.45,1.39,.48,1.94,.05-.07,.37-1.25,.69-1.62,.8-.95,.28-1.45-.14-2.38-.53,0,0,1.46,.22,2.05-.32Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "82.55 187.85 82.64 159 84.12 150.22 84.68 150.32 83.21 159.05 83.1 188.4 82.55 187.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M83.15,158.85l-.45,.35c-.45-.59-.86-1.36-1.33-2.25-.73-1.38-1.56-2.94-2.82-4.32l.42-.38c1.31,1.44,2.15,3.03,2.9,4.44,.46,.87,.86,1.62,1.28,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M83.5,154.98c.77-.2,1.46-.69,1.9-1.35,.5-.75,.68-1.66,.84-2.55-1,.3-2.07-.19-3.1-.07-.82,.09-1.59,.6-2.01,1.31-.54,.93-.76,1.98-.28,2.41,.39,.35,1.62,.52,2.65,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79.66,152.99c-.92,.58-2.1,.73-3.14,.39-1.04-.34-1.34-1.89-1.74-2.91,.94-.19,3.32-.06,3.86,0,.54,.05,1.09,.3,1.38,.76,.29,.46,.24,1.15-.2,1.46-.03-.02-.16,.3-.16,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M74.93,154.67c.63-.77,2.19-1.32,3.17-1.14,.98,.18,1.81,.85,2.16,1.65-.26,.62-.95,.97-1.62,1.02-.67,.05-1.33-.15-1.97-.35-.64-.2-1.3-.39-1.97-.35l.24-.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M94.18,149.71s1.04,.93,1.25,2.24c.21,1.3-2.16,2.86-2.16,2.86,0,0-1.76,.56-3-.53l-1.24-1.1s3.77-3.51,4.98-3.19l.16-.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M88.02,147.78c-.8,1.97-.33,4.91,1.43,5.63s4.14-1.07,4.94-3.04c.8-1.97-.6-2.62-2.36-3.33-1.76-.71-3.22-1.22-4.01,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M93.51,148.82s-1.72,.68-4.37-.84c0,0,3.57,4.38,4.37,.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M92.41,148.04s-1.51-.77-1.74-.11c0,0-1.33-.49-.97-1,.36-.51,2.7,1.11,2.7,1.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.51,148.82s-1.72,.68-4.37-.84c0,0,3.57,4.38,4.37,.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M92.41,148.04s-1.51-.77-1.74-.11c0,0-1.33-.49-.97-1,.36-.51,2.7,1.11,2.7,1.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M92.29,154.98c-.86,.76-2.18,.87-3.23,.41s-1.82-1.45-2.17-2.54c-.35-1.09-.31-2.28-.05-3.4,.07-.29,.26-1,.67-1,.37,0,.44,.55,.53,.82,.26,.78,.56,1.53,.97,2.25,.4,.69,.89,1.34,1.44,1.92,.15,.16,1.69,1.67,1.84,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M85.78,148.55c-.59,.72-.78,1.75-.46,2.63,.21,.58,.6,1.06,1.01,1.52,.28,.32,.67,.65,1.08,.54,.44-.12,.57-.68,.62-1.13,.07-.7,.13-1.41,.16-2.11,.03-.58,.22-1.5,.05-2.06-.16-.52-.66-.4-1.2-.22-.49,.16-.93,.44-1.26,.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M92.18,153.72c.71,.19,1.51-.08,1.97-.66,.34-.42,.71-1.65,.13-1.99-.61,1-1.15,1.91-2.1,2.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.48,152.22c-.6-.39-.99-1.1-.98-1.82,0-.4,.71-2.2,1.02-1.26,.1,.31-.18,1.11-.19,1.47-.01,.54,.04,1.08,.15,1.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M89.65,154.14c-.64,.28-1.47,.05-1.87-.52-.04,.38,1,1.03,1.31,1.24,.83,.55,1.43,.29,2.43,.2,0,0-1.47-.22-1.87-.91Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "81.73 183.54 82.09 182.36 82.57 180.77 83.13 178.91 87.62 164.14 88.18 159.9 88.68 156.14 88.78 155.36 89.06 155.39 89.06 155.4 89.35 155.43 89.34 155.5 89.24 156.24 88.71 160.26 88.27 163.53 88.18 164.25 88.14 164.37 83.13 180.87 82.56 182.72 82.3 183.58 81.95 184.75 81.73 183.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M87.73,163.96l.33,.46c.61-.43,1.22-1.05,1.94-1.76,1.1-1.1,2.35-2.35,3.96-3.3l-.29-.49c-1.67,.99-2.95,2.27-4.07,3.39-.7,.7-1.3,1.3-1.86,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M88.54,160.16c-.67-.42-1.19-1.09-1.42-1.85-.26-.86-.16-1.79-.06-2.68,.86,.58,2.03,.43,2.98,.85,.76,.33,1.34,1.04,1.53,1.84,.24,1.05,.14,2.12-.44,2.38-.48,.22-1.7,.02-2.6-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M92.79,159.39c.71,.83,1.8,1.32,2.88,1.3,1.09-.02,1.84-1.42,2.52-2.27-.84-.46-3.16-1.03-3.69-1.14-.53-.11-1.13-.04-1.54,.32-.41,.35-.56,1.03-.24,1.46,.03-.01,.07,.33,.07,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M96.82,162.39c-.38-.92-1.71-1.91-2.69-2.02-.99-.12-1.98,.28-2.55,.94,.06,.67,.62,1.21,1.25,1.45,.63,.24,1.32,.25,1.99,.25,.67,0,1.36,0,1.99,.25l.02-.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M73.92,148.56s-1.15,.81-1.51,2.07c-.36,1.27,1.81,3.1,1.81,3.1,0,0,1.68,.77,3.04-.18l1.36-.94s-3.34-3.93-4.57-3.75l-.13-.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M80.26,147.37c.56,2.05-.25,4.92-2.08,5.42-1.83,.5-3.99-1.55-4.55-3.6-.56-2.05,.9-2.53,2.74-3.03s3.34-.84,3.9,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M74.69,147.75s1.63,.87,4.44-.32c0,0-4.06,3.93-4.44,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M75.87,147.11s1.59-.59,1.74,.1c0,0,1.38-.33,1.08-.88-.3-.55-2.82,.78-2.82,.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M74.69,147.75s1.63,.87,4.44-.32c0,0-4.06,3.93-4.44,.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M75.87,147.11s1.59-.59,1.74,.1c0,0,1.38-.33,1.08-.88-.3-.55-2.82,.78-2.82,.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M75.17,154.02c.77,.85,2.07,1.13,3.16,.79,1.1-.34,1.98-1.22,2.45-2.26,.48-1.04,.58-2.23,.44-3.37-.03-.29-.15-1.03-.55-1.07-.37-.04-.5,.49-.62,.75-.35,.75-.73,1.46-1.23,2.12-.48,.64-1.04,1.22-1.65,1.74-.17,.14-1.87,1.46-2.01,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M82.4,148.39c.51,.78,.57,1.83,.15,2.66-.27,.55-.72,.98-1.18,1.39-.32,.28-.74,.57-1.14,.41-.42-.18-.49-.74-.48-1.2,0-.71,.04-1.41,.09-2.12,.04-.58-.05-1.52,.19-2.05,.22-.5,.7-.31,1.22-.08,.46,.21,.87,.55,1.15,.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M75.44,152.77c-.72,.1-1.49-.26-1.88-.88-.28-.46-.51-1.72,.1-2,.49,1.07,.92,2.04,1.77,2.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M80.28,151.84c.64-.32,1.11-.98,1.19-1.69,.05-.39-.45-2.27-.87-1.37-.14,.3,.05,1.13,.02,1.48-.05,.54-.17,1.07-.34,1.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M77.9,153.49c.61,.35,1.45,.22,1.92-.3,0,.38-1.11,.9-1.45,1.07-.89,.45-1.45,.12-2.43-.09,0,0,1.48-.04,1.96-.68Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "83.26 192.1 78.17 163.7 78.05 154.81 78.62 154.8 78.74 163.66 83.91 192.54 83.26 192.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M78.65,163.47l-.38,.42c-.55-.5-1.09-1.18-1.72-1.98-.97-1.22-2.06-2.61-3.55-3.75l.35-.45c1.54,1.18,2.66,2.6,3.65,3.85,.61,.77,1.13,1.44,1.65,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M78.29,159.6c.72-.34,1.31-.94,1.63-1.67,.36-.83,.37-1.76,.37-2.66-.93,.47-2.07,.19-3.06,.49-.79,.24-1.46,.87-1.74,1.65-.36,1.01-.39,2.09,.15,2.42,.45,.27,1.68,.22,2.65-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M74.16,158.33c-.8,.74-1.94,1.1-3.02,.95-1.08-.15-1.66-1.62-2.23-2.55,.89-.36,3.26-.65,3.8-.7s1.12,.1,1.49,.5c.37,.4,.44,1.08,.06,1.48-.03-.01-.11,.32-.11,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M69.81,160.84c.48-.87,1.92-1.69,2.91-1.69,.99,0,1.93,.51,2.42,1.24-.14,.66-.76,1.13-1.41,1.29s-1.34,.09-2,.01c-.67-.08-1.35-.15-2,.01l.08-.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M85.35,174.68h-5.98c-.45,0-.85,.28-.98,.71-.49,1.55-1.54,5.63-1.54,12.06,0,7.06,1.84,16.43,2.42,19.2,.1,.47,.51,.8,.98,.8h4.16c.48,0,.88-.34,.98-.8,.58-2.77,2.42-12.14,2.42-19.2,0-6.43-1.05-10.5-1.54-12.06-.13-.41-.5-.69-.93-.71Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "&lt;Path&gt;",
    className: "cls-13",
    cx: 250,
    cy: 360.74,
    rx: 193.89,
    ry: 11.32
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M120.78,321.82c-.34-.02-.61-.31-.6-.65,.74-29.39,2.26-77.6,2.34-77.87,.1-.34,.46-.52,.79-.43,.34,.1,.53,.46,.43,.79-.02,.06-1.55,48.44-2.28,77.53,0,.35-.3,.63-.65,.62,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.83,223.68c.25,2.26,2.96,10.11,5.22,9.87,2.26-.25,3.22-8.49,2.98-10.76-.25-2.26-2.28-3.9-4.54-3.65-2.26,.25-3.9,2.28-3.65,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.82,248.43c-.25-2.26-2.96-10.11-5.22-9.86-2.26,.25-3.22,8.49-2.98,10.76,.25,2.26,2.28,3.9,4.54,3.65,2.26-.25,3.9-2.28,3.65-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.95,241.55c2.26-.25,10.11-2.96,9.86-5.22-.25-2.26-8.49-3.22-10.76-2.98-2.26,.25-3.9,2.28-3.65,4.54,.25,2.26,2.28,3.9,4.54,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.7,230.56c-2.26,.25-10.11,2.96-9.87,5.22,.25,2.26,8.49,3.22,10.76,2.98,2.26-.25,3.9-2.28,3.65-4.54-.25-2.26-2.28-3.9-4.54-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.69,231.19c1.78,1.43,9.24,5.06,10.67,3.28,1.43-1.78-3.73-8.29-5.5-9.71-1.77-1.43-4.37-1.14-5.8,.63-1.43,1.77-1.14,4.37,.63,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.96,240.92c-1.77-1.43-9.24-5.06-10.67-3.28-1.43,1.77,3.73,8.28,5.5,9.71,1.77,1.43,4.37,1.14,5.8-.63,1.43-1.77,1.14-4.37-.63-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.46,248.69c1.43-1.77,5.06-9.24,3.28-10.67-1.77-1.43-8.28,3.73-9.71,5.5-1.43,1.77-1.14,4.37,.63,5.8,1.77,1.43,4.37,1.14,5.8-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.19,223.42c-1.43,1.77-5.06,9.24-3.28,10.67,1.77,1.43,8.28-3.73,9.71-5.5,1.43-1.77,1.14-4.37-.63-5.8-1.77-1.43-4.37-1.14-5.8,.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.83,223.68c.25,2.26,2.96,10.11,5.22,9.87,2.26-.25,3.22-8.49,2.98-10.76-.25-2.26-2.28-3.9-4.54-3.65-2.26,.25-3.9,2.28-3.65,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.82,248.43c-.25-2.26-2.96-10.11-5.22-9.86-2.26,.25-3.22,8.49-2.98,10.76,.25,2.26,2.28,3.9,4.54,3.65,2.26-.25,3.9-2.28,3.65-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.95,241.55c2.26-.25,10.11-2.96,9.86-5.22-.25-2.26-8.49-3.22-10.76-2.98-2.26,.25-3.9,2.28-3.65,4.54,.25,2.26,2.28,3.9,4.54,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.7,230.56c-2.26,.25-10.11,2.96-9.87,5.22,.25,2.26,8.49,3.22,10.76,2.98,2.26-.25,3.9-2.28,3.65-4.54-.25-2.26-2.28-3.9-4.54-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.69,231.19c1.78,1.43,9.24,5.06,10.67,3.28,1.43-1.78-3.73-8.29-5.5-9.71-1.77-1.43-4.37-1.14-5.8,.63-1.43,1.77-1.14,4.37,.63,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.96,240.92c-1.77-1.43-9.24-5.06-10.67-3.28-1.43,1.77,3.73,8.28,5.5,9.71,1.77,1.43,4.37,1.14,5.8-.63,1.43-1.77,1.14-4.37-.63-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.46,248.69c1.43-1.77,5.06-9.24,3.28-10.67-1.77-1.43-8.28,3.73-9.71,5.5-1.43,1.77-1.14,4.37,.63,5.8,1.77,1.43,4.37,1.14,5.8-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.19,223.42c-1.43,1.77-5.06,9.24-3.28,10.67,1.77,1.43,8.28-3.73,9.71-5.5,1.43-1.77,1.14-4.37-.63-5.8-1.77-1.43-4.37-1.14-5.8,.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.47,236.58c.29,2.68,2.7,4.62,5.38,4.33,2.68-.29,4.62-2.7,4.33-5.38-.29-2.68-2.7-4.62-5.38-4.33-2.68,.29-4.62,2.7-4.33,5.38Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.95,300.29c-5.63,.12-15.27-5.08-19.07-10.16-3.85-5.15,6.95-1.98,5.83-6.03-1.12-4.05-14.41-1.02-16.88-6.82-2.47-5.8,7.13-4.5,6.74-7.46-.39-2.97-10.33-2.34-13.54-8.5-3.21-6.17,5.54-2.73,4.16-5.29-1.38-2.56-12.37-13.3-7.79-15.56,4.58-2.26,14.88,8.93,18.33,10.17,3.45,1.24,4.23-6.51,8.72-2.82,4.49,3.69,1.18,19.91,6.46,22.03,3.93,1.58,2.24-5.83,6.77-3.97,7.92,3.25,2.56,34.36,.27,34.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.95,300.29c-5.63,.12-15.27-5.08-19.07-10.16-3.85-5.15,6.95-1.98,5.83-6.03-1.12-4.05-14.41-1.02-16.88-6.82-2.47-5.8,7.13-4.5,6.74-7.46-.39-2.97-10.33-2.34-13.54-8.5-3.21-6.17,5.54-2.73,4.16-5.29-1.38-2.56-12.37-13.3-7.79-15.56,4.58-2.26,14.88,8.93,18.33,10.17,3.45,1.24,4.23-6.51,8.72-2.82,4.49,3.69,1.18,19.91,6.46,22.03,3.93,1.58,2.24-5.83,6.77-3.97,7.92,3.25,2.56,34.36,.27,34.41Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.05,293.14c.09,.16-.75,.96,2.03,1.07,6.85,.28,18.96-.18,23.51-6.41,6.49-8.89-8.48-8.08-7.03-12.98,1.46-4.9,17.55-.9,20.69-7.9,3.14-7-8.56-5.63-8.02-9.24,.54-3.6,12.82,1.07,16.87-6.36,4.05-7.43-6.68-3.45-4.94-6.53,1.74-3.08,15.36-15.89,9.84-18.74-5.52-2.85-18.31,10.52-22.53,11.95-4.22,1.43-5.2-11.68-10.74-7.3-5.55,4.39-1.91,24.19-8.38,26.64-4.82,1.83-2.19-5.26-8.14-4.99-8.08,.37-10.73,28.13-3.17,40.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.05,293.14c.09,.16-.75,.96,2.03,1.07,6.85,.28,18.96-.18,23.51-6.41,6.49-8.89-8.48-8.08-7.03-12.98,1.46-4.9,17.55-.9,20.69-7.9,3.14-7-8.56-5.63-8.02-9.24,.54-3.6,12.82,1.07,16.87-6.36,4.05-7.43-6.68-3.45-4.94-6.53,1.74-3.08,15.36-15.89,9.84-18.74-5.52-2.85-18.31,10.52-22.53,11.95-4.22,1.43-5.2-11.68-10.74-7.3-5.55,4.39-1.91,24.19-8.38,26.64-4.82,1.83-2.19-5.26-8.14-4.99-8.08,.37-10.73,28.13-3.17,40.78Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M120.92,317.38s-.02,0-.04,0c-.24-.03-.42-.25-.39-.5,5.62-46.02,32.13-64.72,32.4-64.9,.2-.14,.48-.09,.62,.11,.14,.2,.09,.48-.11,.62-.26,.18-26.45,18.68-32.02,64.28-.03,.23-.23,.4-.46,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M146.85,258.37c-.18,0-.35-.13-.41-.31-.08-.23,.05-.49,.29-.56,.16-.05,4.11-1.3,10.58,.07,.24,.05,.39,.29,.34,.53-.05,.24-.29,.4-.53,.34-6.22-1.32-10.08-.11-10.12-.1-.05,.02-.1,.02-.16,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M141.96,263.96c-.24,0-.42-.2-.43-.44-.14-13.92,7.92-24.79,8-24.9,.15-.2,.43-.24,.62-.09,.2,.15,.24,.43,.09,.62-.08,.11-7.96,10.75-7.82,24.35,0,.25-.2,.45-.44,.45,0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M134.06,275.74c-.11,0-.22-.05-.31-.14-.17-.18-.16-.46,.02-.63,.06-.06,6.02-5.57,13.83-2.77,.23,.08,.35,.34,.27,.57-.08,.23-.34,.35-.57,.27-7.3-2.62-12.87,2.53-12.92,2.58-.09,.08-.21,.13-.32,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M129.93,283.95c-.17,0-.32-.11-.39-.27-.13-.29-3.05-7.29-1.44-17.26,.04-.24,.26-.41,.51-.37,.24,.04,.41,.27,.37,.51-1.57,9.7,1.35,16.7,1.38,16.77,.1,.23,0,.49-.24,.58-.06,.03-.13,.04-.19,.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M121.09,333.82c-.23,0-.42-.2-.43-.43l-.58-12.19c-1.71-40.52-29.5-68.09-29.78-68.36-.18-.17-.18-.45,0-.63,.17-.18,.45-.18,.63,0,.28,.28,28.33,28.07,30.05,68.97l.58,12.19c0,.25-.19,.45-.43,.46-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M101.77,268.06s-.05,0-.07,0c-.04,0-.09-.03-.13-.05l-.14-.06c-3.64-1.51-7.7-2.3-11.45-2.21-.25,.01-.45-.19-.46-.44,0-.25,.19-.45,.44-.46,3.86-.08,8.06,.72,11.81,2.28l.15,.06s.05,.02,.08,.04c.17,.09,.28,.29,.23,.49-.04,.22-.24,.36-.45,.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M105.7,273.28s-.01,0-.02,0c-.24-.02-.43-.24-.4-.48,1.08-11.96-5.12-21.8-5.18-21.9-.13-.21-.07-.48,.14-.62,.21-.13,.48-.07,.62,.14,.06,.1,6.42,10.19,5.32,22.46-.02,.24-.23,.41-.46,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M109.76,280.21c-.11,0-.22-.05-.3-.13-.05-.05-4.56-4.5-11.17-2.74-.24,.07-.48-.08-.55-.32-.06-.24,.08-.48,.32-.55,7.12-1.9,11.83,2.78,12.03,2.98,.17,.18,.17,.46,0,.63-.09,.09-.21,.13-.33,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M114.91,291.63c-.06,0-.13-.02-.19-.05-.22-.11-.3-.38-.19-.6,.03-.06,3.09-6.04,2.39-14.67-.02-.25,.16-.46,.41-.48,.25-.03,.46,.16,.48,.41,.72,8.9-2.36,14.9-2.49,15.15-.08,.16-.25,.25-.41,.24Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.16,335.74c0,14.21-6.39,25.74-25.75,25.74s-25.75-11.53-25.75-25.74c0-5.36,1.65-10.35,4.45-14.47h42.61c2.8,4.12,4.45,9.11,4.45,14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.16,335.74c0,14.21-6.39,25.74-25.75,25.74s-25.75-11.53-25.75-25.74c0-5.36,1.65-10.35,4.45-14.47h42.61c2.8,4.12,4.45,9.11,4.45,14.47Z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "294.1 348.91 304.06 347.46 301.55 324.15 291.58 325.61 294.1 348.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.72,347.81c.87-.06,1.68-.42,2.32-1.01,.27-.34,.36-.8,.23-1.22-.06-.26-.25-.48-.5-.56-1.33-.48-4.97,2.21-5.38,2.51-.08,.06-.11,.17-.09,.27,.03,.09,.12,.16,.22,.16,1.07,.05,2.14,0,3.2-.15Zm1.4-2.34c.15-.04,.31-.03,.45,.01,.1,.03,.18,.12,.21,.23,.08,.28,.03,.58-.15,.8-.51,.64-2.14,1-4.41,1,1.18-.9,2.51-1.6,3.92-2.06h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M308.58,347.96l.08-.04c1.11-.73,3.1-3.26,2.72-4.36-.11-.25-.32-.56-.99-.52-.48,0-.94,.22-1.26,.59-1.08,1.24-.86,3.97-.86,4.08,0,.08,.03,.16,.1,.21,.06,.05,.13,.06,.21,.04Zm1.67-4.42l.13-.06c.44-.02,.49,.14,.5,.2,.23,.66-1.09,2.61-2.19,3.51-.1-1.15,.16-2.3,.76-3.28,.21-.22,.5-.36,.81-.38h-.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M303.04,343.33l-8.83,2.1c-.4,.08-.67,.45-.63,.86l.29,12.78c.12,.9,.95,1.52,1.84,1.4,.06,0,.12-.02,.18-.04,3.83-.95,5.63-1.6,10.5-2.72,2.98-.69,12.43-1.4,16.3-3.12,3.87-1.72,2.36-5.65,.6-5.27-5.68,1.22-12.97-1.21-17.11-4.91-.56-.28-2.53-1.23-3.13-1.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "301.55 324.15 302.84 336.17 292.88 337.63 291.58 325.62 301.55 324.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M306.87,331.22l-18.43,3.44s-8.95-12.78-10.64-21.85c-1.76-9.45,.12-41.61,0-42.04-5.21-17.6-19.38-63.2-26.21-79.98-3.79-9.3-6.45-15.56-6.45-15.56l1.91-.43,15.04-6.16,10.96,2.07s33.31,67.36,36.81,92.7c2.61,18.92-3,67.81-3,67.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M306.87,331.22l-18.43,3.44s-8.95-12.78-10.64-21.85c-1.76-9.45,.12-41.61,0-42.04-5.21-17.6-19.38-63.2-26.21-79.98-3.79-9.3-6.45-15.56-6.45-15.56l1.91-.43,15.04-6.16,10.96,2.07s33.31,67.36,36.81,92.7c2.61,18.92-3,67.81-3,67.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M273.46,255.54c-5.21-17.6-15.73-44.29-22.57-61.07l-4.53-15.99-.87-3.08,1.59,2.91,17.85,39.55c7.88,15.14,8.65,38.11,8.53,37.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "192.57 343.42 201.45 347.16 210.92 326.84 202.05 323.1 192.57 343.42"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.23,351.42c.7,.44,1.54,.63,2.36,.53,.4-.11,.73-.41,.86-.81,.1-.23,.08-.51-.07-.72-.76-1.12-5.09-1.11-5.57-1.1-.1,0-.18,.07-.22,.15-.03,.09,0,.19,.08,.25,.8,.64,1.65,1.21,2.55,1.69Zm2.4-1.01c.14,.06,.26,.15,.34,.27,.06,.08,.07,.2,.03,.29-.09,.26-.3,.46-.57,.54-.76,.2-2.21-.44-3.97-1.72,1.42-.03,2.84,.18,4.19,.63h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.72,349.77l.08,.02c1.26,.06,4.24-.77,4.57-1.83,.05-.25,.07-.61-.47-.96-.38-.27-.85-.36-1.3-.26-1.53,.35-2.91,2.57-2.97,2.66-.05,.06-.07,.15-.04,.22,.02,.07,.07,.12,.14,.15Zm3.79-2.47l.14,.03c.35,.23,.3,.39,.28,.44-.19,.64-2.31,1.4-3.67,1.48,.57-.94,1.43-1.68,2.44-2.1,.29-.05,.59,0,.84,.17h-.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M203.06,343.06l-8.01-3.37c-.35-.16-.77-.03-.97,.31l-7,10.03c-.41,.76-.13,1.71,.63,2.12,.05,.03,.11,.05,.16,.08,3.49,1.43,5.25,1.95,9.65,3.83,2.69,1.16,10.39,5.94,14.35,6.8,3.96,.86,5.01-3.02,3.44-3.74-5.07-2.27-9.33-8.26-10.44-13.46-.28-.53-1.26-2.38-1.81-2.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "211.31 327.08 206.17 337.43 197.39 333.49 202.51 323.13 211.31 327.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.16,338.36l-17.68-9.42s-3.39-12.59,0-20.62c6.52-15.45,23.5-38.17,23.61-38.6,4.53-17.79,12.47-66.49,15.19-84.41,1.51-9.93,2.39-12.07,2.39-12.07l1.87,.61,27.05,.05s5.1,40.97-14.46,104.4c-4.87,15.78-13.02,28.9-26.44,46.66-5.09,6.74-11.54,13.4-11.54,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M213.16,338.36l-17.68-9.42s-3.39-12.59,0-20.62c6.52-15.45,23.5-38.17,23.61-38.6,4.53-17.79,12.47-66.49,15.19-84.41,1.51-9.93,2.39-12.07,2.39-12.07l1.87,.61,27.05,.05s5.1,40.97-14.46,104.4c-4.87,15.78-13.02,28.9-26.44,46.66-5.09,6.74-11.54,13.4-11.54,13.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M289.56,140.43c.2-3.04,2.21-6.95,3.95-8.76,.56-.58,2.67-1.46,3.86-2.24,5.87-3.85,17.63-8.66,17.63-8.66l3.63,3.16s-7.16,6.92-11.42,10.24c-.84,.65-1.81,1.44-2.83,2.28-1.85,1.55-10.57,7.3-12.24,8.74l-2.58-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M325.34,118.99l-6.71,4.96-3.76-2.77s1.54-1.96,3.11-3.47c.69-.67,1.07-1.58,1.08-2.54,.01-1.48,.24-3.19,1.04-4.45,.02-.03,.03-.06,.05-.08,1.45-2.19,4.86-1.53,5.54,1l.97,3.58c.38,1.41-.14,2.91-1.32,3.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M291.7,141.77l-1.77,1.62c-.55-.44-1.43-1.15-2.53-2.06-8.62-7.16-30.23-24.51-21.61-29.47,7.38-4.25,15.23,8.75,19.14,12.65,.8,.81,2.98,3.32,4.74,6.48,1.84,3.31,3.2,7.32,2.03,10.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M289.66,129.44c-3.06,2.24-5.67,5.08-7.64,8.32,1.42,4.7,4.99,8.78,9.49,10.74,2.47-5.72,3.61-11.88,3.13-18.09-1.56-.34-3.42-.63-4.98-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M242.21,110.85c-3.08,.99-6.61,.2-8.59,2.76-1.98,2.56-2.57,5.95-2.57,9.19,0,4.5,1.03,8.94,2.06,13.32,1.24,5.32,2.48,10.64,3.73,15.96,.85,3.64-.04,20.54,.86,20.83,0,0,28.27-.55,35.36-1.55,0,0,.62-17.38,1.18-23.3,.13-1.31,2.12-6.89,2.35-8.29,1.1-6.6-1.06-11.26-3.35-17.55,0,0-5.01-10.08-7.45-10.35-4.35-.49-14.99-3.78-23.58-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M241.02,119.19c-.1-.59-5.12-10.72-9.93-3.64-6.69,9.86-7.14,22.24-7.14,22.24,0,0-4.11,12.04-1.25,14.67,2.87,2.63,5.96,4.32,7.96,2.83,2-1.49,3.3-4.47,3.3-4.47,0,0,8.81-21.31,7.06-31.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M240.69,107.09c-2.11,1.65-1.83,5.46,.49,6.79-.58,2.04,.1,4.4,1.69,5.81,1.59,1.41,4.01,1.81,5.97,.99-.85,1.52,.11,3.52,1.57,4.46,1.46,.94,3.27,1.11,4.99,1.34s3.54,.6,4.8,1.81c1.78-2.56,3.56-5.13,5.35-7.69,.69-1,1.41-2.07,1.47-3.28,.05-1.21-.87-2.55-2.08-2.46,1.23-1.28,1.26-3.54,.05-4.85-1.2-1.31-3.45-1.48-4.84-.36,.25-1.03-.35-2.12-1.22-2.72-.87-.6-1.95-.81-3-.91l-15.24,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.9,94.04c1.39,5.1,3.08,14.51-.3,18.23,0,0,9.55,3.82,16.33,11.49,3.16-3.07,2.83-6.52,1.86-9.04-.75-1.95-2.36-3.4-4.29-4.22-3.72-1.58-3.75-5.24-3.13-8.74l-10.48-7.72Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M245.98,102.73l3.51,.95c1.5,.41,3.08,.5,4.62,.27h0c-.01,.76-.15,2.36,.33,3.21-2.02,.97-5.43,.31-6.93-1.47-.62-.69-1.18-2.1-1.52-2.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M237.09,89.7c3.72,7.84,5.12,11.24,10.85,13.74,8.62,3.77,17.42-2.53,16.11-11.32-1.17-7.91-7.06-19.41-16.21-19.45-6.54-.06-11.89,5.18-11.96,11.72-.02,1.84,.39,3.66,1.2,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M241.17,74.72c-2.71-1.26-6.07-.23-8.33,1.75-2.29,2.02-3.69,4.84-5.03,7.59-.73,1.49-1.46,3.01-1.8,4.63-.34,1.63-.24,3.41,.62,4.83,.84,1.39,2.41,2.31,4.03,2.4,.93,.05,2.02,.73,2.33,1.61,.28,.82,.15,1.71,.02,2.56-.13,.83-.25,1.69,.01,2.48,.43,1.32,1.84,2.12,3.23,2.26,1.38,.13,2.75-.27,4.09-.66,.84-.25,1.69-.11,2.35,.48,.16,.15,.3,.32,.4,.52,.41,.79,1.61,.66,1.96-.16,1.21-2.88-.55-7.47-3.17-10.98-1.39-1.86-1.32-1.39-1.86-3.65-.46-1.88,.23-3.84,1.08-5.58,1.12-2.32,2.57-4.59,2.12-7.36-.19-1.17-.95-2.22-2.02-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M237.32,97.72c1.23,1.31,2.94,2.08,4.74,2.14,2.39,.05,2.99-2.23,1.84-4.17-1.04-1.75-3.54-3.88-5.7-3.04-2.16,.85-2.38,3.43-.88,5.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.03,88.3c.28,.69,.82,1.05,1.25,.87,.43-.18,.54-.83,.3-1.5-.24-.67-.82-1.04-1.25-.87-.43,.17-.56,.84-.3,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.35,85.15c.27,.69,.82,1.05,1.25,.88,.42-.17,.54-.83,.3-1.5s-.82-1.04-1.25-.88-.56,.84-.3,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.46,83.78l1.39-1.09s-.3,1.55-1.39,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M257.45,86.62c1.7,1.68,2.98,1.98,4.82,3.14-.05,1.63-1.59,2.01-1.59,2.01l-3.23-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.9,94.97c.32-.12,.62-.26,.92-.43,.1-.05,.13-.17,.08-.27,0,0,0,0,0,0-.06-.1-.18-.13-.28-.09-1.55,.9-3.44,1-5.08,.27-.1-.05-.23-.02-.28,.09-.05,.1-.02,.23,.09,.28,1.44,.66,3.08,.72,4.56,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M251.76,82.86c-.01,.19-.14,.35-.32,.4-1.92,.57-2.77,3-2.77,3.02-.08,.23-.32,.35-.55,.27-.23-.08-.35-.32-.27-.55,.07-.09,1-2.88,3.34-3.58,.23-.06,.47,.07,.54,.29,.02,.05,.03,.09,.04,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M260.61,81.68c-.16,.1-.36,.08-.51-.04-1.56-1.25-4.05-.56-4.06-.56-.23,.07-.47-.06-.54-.29-.07-.23,.06-.47,.29-.54,.12,0,2.94-.82,4.85,.7,.18,.15,.21,.42,.07,.61-.02,.04-.06,.08-.1,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.16,86.92l1.39-1.08s-.32,1.55-1.39,1.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M241.77,73.41c-2.18,.17-4.26,1.42-5.44,3.26-.79,1.24-1.07,3.12,.1,4,.55,.41,1.28,.49,1.96,.55,3.04,.27,6.8-2.08,6.8-2.08-1.17-4.97,9.25-8.82,14.39-1.12,1.51,2.26,1.1,3.9,3.61,4.95,1.18,.49,2.74,.36,3.5,1.39,1.26,1.71-1.16,4.61,.38,6.08,1.05,1.01,3.43,.62,3.57,2.07,.07,.68-.38,1.66,.28,1.86,.36,.11,.69-.22,.93-.52,.57-.72,1.15-1.47,1.34-2.36,.19-.89-.12-1.97-.96-2.35-.64-.29-2.33,.03-2.21,.73,.14,.83-.58-3.26-.26-4.8,.28-1.35,1.56-2.51,1.17-3.83-.42-1.41-2.09-1.97-3.54-2.18-1.45-.21-3.1-.39-3.99-1.55-.99-1.3-.54-3.16-.86-4.76-.41-2.04-2.11-3.63-4.02-4.46-5.8-2.51-14.76-2.16-16.76,5.13Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.24,100.09l-19.99,10.04c-6.57,3.3-9.55,11.07-6.86,17.92l9.64,24.59c2.69,6.85,10.15,10.53,17.22,8.49l21.5-6.2c8.06-2.32,12.37-11.07,9.31-18.88l-11.15-28.44c-3.06-7.81-12.17-11.3-19.66-7.53Zm-3.3,42.24c-4.46,1.75-9.49-.45-11.24-4.91-1.75-4.46,.45-9.49,4.91-11.23,4.46-1.75,9.49,.45,11.24,4.91,1.75,4.46-.45,9.49-4.91,11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.24,100.09l-19.99,10.04c-6.57,3.3-9.55,11.07-6.86,17.92l9.64,24.59c2.69,6.85,10.15,10.53,17.22,8.49l21.5-6.2c8.06-2.32,12.37-11.07,9.31-18.88l-11.15-28.44c-3.06-7.81-12.17-11.3-19.66-7.53Zm-3.3,42.24c-4.46,1.75-9.49-.45-11.24-4.91-1.75-4.46,.45-9.49,4.91-11.23,4.46-1.75,9.49,.45,11.24,4.91,1.75,4.46-.45,9.49-4.91,11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.05,136.07l-11.16-28.44c-3.06-7.81-12.17-11.3-19.66-7.54l-5.81,2.92-3.9,1.96-10.28,5.17c-6.58,3.3-9.55,11.07-6.87,17.92l9.64,24.59c2.69,6.85,10.15,10.53,17.22,8.49l21.51-6.2c1.76-.51,3.34-1.33,4.71-2.38,1.06-.81,1.99-1.75,2.76-2.8,2.82-3.79,3.71-8.92,1.84-13.69Zm-34.13,6.26c-4.45,1.75-9.49-.45-11.23-4.91-1.75-4.45,.45-9.49,4.91-11.23,4.45-1.75,9.49,.45,11.23,4.9,1.74,4.46-.45,9.49-4.91,11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.44,101.96l-18.75,9.42c-6.17,3.1-8.95,10.38-6.44,16.8l9.04,23.06c2.52,6.42,9.52,9.88,16.15,7.96l20.17-5.82c7.56-2.18,11.6-10.38,8.73-17.7l-10.46-26.67c-2.87-7.32-11.42-10.6-18.44-7.06Zm-14.75,35.45c-1.75-4.46,.45-9.49,4.91-11.23,4.46-1.75,9.49,.45,11.24,4.91,1.75,4.46-.45,9.49-4.91,11.23-4.46,1.75-9.49-.45-11.24-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.44,101.96l-18.75,9.42c-6.17,3.1-8.95,10.38-6.44,16.8l9.04,23.06c2.52,6.42,9.52,9.88,16.15,7.96l20.17-5.82c7.56-2.18,11.6-10.38,8.73-17.7l-10.46-26.67c-2.87-7.32-11.42-10.6-18.44-7.06Zm-14.75,35.45c-1.75-4.46,.45-9.49,4.91-11.23,4.46-1.75,9.49,.45,11.24,4.91,1.75,4.46-.45,9.49-4.91,11.23-4.46,1.75-9.49-.45-11.24-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.62,93.07l-.57,1.05-.32,.58-.9,1.65,.38,4.23c.02,.18,0,.36-.06,.53-.12,.37-.4,.67-.77,.82l-7.9,3.09c-.37,.15-.78,.11-1.12-.08-.11-.06-.21-.14-.3-.23l-4.47-4.54h-.01s-6.35,2.47-6.35,2.47l.92,2.35-6.35,2.49,1.52,3.87-4.68,1.83c-.38,.15-.81,.12-1.16-.06-.12-.06-.22-.14-.32-.23l-2.7-2.54-6.35,2.49,1.52,3.87-6.68,2.62,1.52,3.88c.25,.63-.06,1.35-.7,1.6l-18.3,7.16-7.94-20.25,66.19-25.91,1.04,.53,3.36,1.72c1.83,.94,2.52,3.2,1.54,5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.62,93.07l-.57,1.05-.32,.58-.9,1.65,.38,4.23c.02,.18,0,.36-.06,.53-.12,.37-.4,.67-.77,.82l-7.9,3.09c-.37,.15-.78,.11-1.12-.08-.11-.06-.21-.14-.3-.23l-4.47-4.54h-.01s-6.35,2.47-6.35,2.47l.92,2.35-6.35,2.49,1.52,3.87-4.68,1.83c-.38,.15-.81,.12-1.16-.06-.12-.06-.22-.14-.32-.23l-2.7-2.54-6.35,2.49,1.52,3.87-6.68,2.62,1.52,3.88c.25,.63-.06,1.35-.7,1.6l-18.3,7.16-7.94-20.25,66.19-25.91,1.04,.53,3.36,1.72c1.83,.94,2.52,3.2,1.54,5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.36,90.76l-70.76,27.7-2.06-5.2,67.47-26.41,3.36,1.72c1.28,.66,2.01,1.26,2,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.36,90.76l-70.76,27.7-2.06-5.2,67.47-26.41,3.36,1.72c1.28,.66,2.01,1.26,2,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.96,94.67l-.68,1.54s-.02,.05-.01,.08l.38,4.19c.01,.15,0,.3-.04,.45-.01,.05-.05,.09-.1,.11l-8.59,3.38s-.1,.02-.14-.01c-.08-.05-.16-.11-.23-.19l-4.91-4.94s-.11-.06-.17-.04l-6.98,2.75c-.08,.03-.12,.13-.09,.21l.83,2.1c.03,.08,0,.18-.09,.21l-5.95,2.34c-.08,.03-.12,.13-.09,.21l1.43,3.63c.03,.08,0,.18-.09,.21l-4.36,1.72s-.1,.02-.14,0c-.09-.05-.18-.12-.26-.19l-3.19-2.94s-.11-.05-.17-.03l-6.93,2.73c-.08,.03-.12,.13-.09,.21l1.47,3.72c.03,.08,0,.18-.09,.21l-26.61,10.47c-.08,.03-.18,0-.21-.09l-2.66-6.66c-.03-.08,0-.18,.09-.21l69.34-27.29c.13-.05,.27,.08,.21,.22l-.87,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.96,94.67l-.68,1.54s-.02,.05-.01,.08l.38,4.19c.01,.15,0,.3-.04,.45-.01,.05-.05,.09-.1,.11l-8.59,3.38s-.1,.02-.14-.01c-.08-.05-.16-.11-.23-.19l-4.91-4.94s-.11-.06-.17-.04l-6.98,2.75c-.08,.03-.12,.13-.09,.21l.83,2.1c.03,.08,0,.18-.09,.21l-5.95,2.34c-.08,.03-.12,.13-.09,.21l1.43,3.63c.03,.08,0,.18-.09,.21l-4.36,1.72s-.1,.02-.14,0c-.09-.05-.18-.12-.26-.19l-3.19-2.94s-.11-.05-.17-.03l-6.93,2.73c-.08,.03-.12,.13-.09,.21l1.47,3.72c.03,.08,0,.18-.09,.21l-26.61,10.47c-.08,.03-.18,0-.21-.09l-2.66-6.66c-.03-.08,0-.18,.09-.21l69.34-27.29c.13-.05,.27,.08,.21,.22l-.87,1.92Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 310.67,
    y1: 116.32,
    x2: 284.06,
    y2: 126.79
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M248.07,124.02c-5.59,2.19-8.35,8.5-6.16,14.09,2.19,5.59,8.5,8.35,14.1,6.16,5.59-2.19,8.35-8.5,6.16-14.09-2.19-5.59-8.5-8.35-14.1-6.16Zm6.86,18.3c-4.46,1.75-9.49-.45-11.24-4.91-1.75-4.46,.45-9.49,4.91-11.23,4.46-1.75,9.49,.45,11.24,4.91,1.75,4.46-.45,9.49-4.91,11.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.21,149.75c-.78,1.05-1.7,2-2.76,2.8l-35.93-47.59-.03-.04s3.17-1.59,3.88-2.06c0,.04,.02,.09,.05,.15,1.57,3.37,29.81,40.04,34.79,46.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.02,154.05c-.23,.11-10.69,3.29-10.69,3.29l-11.67-15.45c3.02-2.96,4.15-7.54,2.51-11.72-2.19-5.59-8.5-8.35-14.1-6.16-.49,.19-.95,.41-1.4,.67l-10.32-13.67s9.07-4.32,10.08-4.95c.27,1.92,35.59,47.59,35.59,48Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M239.19,78.99c-1.17,1.39-1.65,3.34-1.25,5.11,.39,1.77,1.65,3.33,3.3,4.1,.85,.4,1.79,.59,2.64,1,.84,.42,1.63,1.15,1.72,2.09,.1,1.04-.66,2-.59,3.04,.07,.95,.81,1.7,1.56,2.29,.75,.59,1.59,1.14,2,2,.41,.86,.15,2.13-.77,2.38-.19,.3-.27,1.01-.02,1.26,.25,.25,.68,.31,.98,.12,1.41-.87,2.38-2.5,2.39-4.16,.01-1.66-1.03-3.27-2.54-3.95-.27-.55-.06-1.25,.17-1.82,.46-1.14,.92-2.29,1.37-3.43,.18-.45,.02-1.27-.29-1.64-.31-.37-.77-.58-1.22-.77l-2.95-1.26c-1.11-.48-4.42-4.9-.5-6.19-.51-1.14-1.4-1.49-2.62-1.72s-2.57,.62-3.37,1.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M244.54,74.23c-.1,1.16-.2,2.33-.29,3.49,.98-1.6,2.79-4.71,2.72-4.59-.77,.42-1.66,.68-2.43,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M245.86,76.14c1.37-1.26,2.73-2.53,4.1-3.79-1.05-.39-2.33-.1-3.1,.72,.02-.09-.61,1.85-.99,3.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M237.53,170.75c-5.33,6.62-3.56,11.69-10.92,23.41,9.28,6.88,19.46,8.02,32.12,7.04,1.5-2.65,2.25-5.41,3.75-8.06,2.14,2.66,3.87,4.9,6.01,7.56,6.63-1.04,14.51-2.9,19.75-6.28-4.63-5.31-7.51-11.94-10.47-17.8-1.39-2.75-.81-3.9-4.5-7.5-11.75,.54-23.4,.83-35.15,1.37,.31,.02-.9,.25-.59,.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.99,169.64l-.74,3.09c-.11,.24,.18,.47,.58,.45l32.38-1.43c.31,0,.56-.18,.57-.37l.17-3.07c0-.21-.27-.38-.61-.36l-31.82,1.4c-.22,0-.42,.1-.54,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.99,169.64l-.74,3.09c-.11,.24,.18,.47,.58,.45l32.38-1.43c.31,0,.56-.18,.57-.37l.17-3.07c0-.21-.27-.38-.61-.36l-31.82,1.4c-.22,0-.42,.1-.54,.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M246.13,173.19l-.94,.04c-.18,0-.33-.08-.32-.19l.25-3.99c0-.11,.16-.21,.35-.22l.94-.05c.18,0,.33,.08,.32,.2l-.25,3.98c-.01,.11-.17,.22-.35,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M269.51,172.18l-.94,.04c-.18,0-.33-.08-.32-.19l.25-3.98c0-.12,.16-.22,.34-.23l.94-.04c.18,0,.33,.08,.32,.19l-.25,3.98c0,.12-.15,.22-.34,.23Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M250.31,153.77c.06,.29,2.58,4.3,4.55,4.02,.02,0,.03,0,.05,0,.57-.08,1.15,.15,1.5,.61,.79,1.03,1.27,1.62,1.8,2.3,.87,1.1,2.38,1.45,3.64,.86,.38-.17,.75-.37,1.12-.56,1.22-.65,1.84-2.05,1.51-3.39-.36-1.47-.93-2.89-1.68-4.21-.26-.45-.55-.9-1-1.16s-4.79-1.57-6.47-1.52c-1.75,.06-3.42,2.35-5.02,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M255.38,150.58s-26.58-8.05-32.32-2.69c-3.37,3.15-1.78,6.13,.11,8.04,1.4,1.43,4.46,1.08,6.45,.98l20.94-2.05,4.82-4.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M240.1,146.9c-.14-1.44-1.26-2.63-2.55-3.28-1.29-.64-2.76-.84-4.19-1.02-3.34-.42-6.68-.85-10.02-1.27-1.7,2.14-2.92,5.09-2.86,7.83,.05,2.73,1.08,5.44,2.86,7.52,1.6-3.09,3.71-6.27,6.83-7.81,3.12-1.53,6.52-2.59,9.94-1.97Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.25,98.35c-.03-.06-.03-.09,0-.1,.21-.06,.18-.02,0,.1Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.29,55.31l7.41,13.73,30.22-25.66c.27-.23-.04-.64-.33-.44l-28.33,18.7-4.37-8.52-4.6,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M346.97,55.38c0,12.24-12.85,22.16-28.69,22.16-6.08,0-11.72-1.45-16.36-3.96l-16.85,7.32,10.63-11.84c-3.83-3.75-6.12-8.5-6.12-13.67,0-12.24,12.85-22.16,28.69-22.16s28.69,9.92,28.69,22.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img-1.0c029ea8ab2bf3932d148d14424e8e82.svg";
export { ForwardRef as ReactComponent };